import Icon from '../components/Icon.vue'

Icon.register({
  at: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c138 0 248 87.7 248 224 0 75.8-41.4 147.4-150.3 147.4-30.1 0-61.2 0-70.7-34.1-17.6 22.7-48 38.3-75 38.3-59.2 0-96-40.6-96-105.9 0-89.2 63.3-151.5 137.8-151.5 19.5 0 45.3 3.9 60 21.8l0-0.1c0.8-6.6 6.8-12 13.4-12v0h45c15.1 0 26.4 13.8 23.6 28.6l-23.4 121.1c-3.4 17.2-3.9 29.6 13.5 30 37.1-4 58.2-44.9 58.2-83.7 0-102.4-83.9-160-184-160-101.5 0-184 82.5-184 184s82.5 184 184 184c35.3 0 69.9-10.2 99.4-29.2 10.2-6.5 23.7-4.2 31.4 5.1l10.2 12.4c9.1 11.1 6.5 27.6-5.6 35.4-40.1 26.1-87.3 40.2-135.4 40.2-137.1 0-248-110.9-248-248 0-137.1 110.9-248 248-248zM234.3 312.4c24.3 0 58.2-27.7 58.2-72.7 0-25.5-13.3-40.8-35.6-40.8-27.9 0-58.6 27.7-58.6 72.7 0 25.1 13.8 40.8 36.1 40.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/at.js
// module id = 632
// module chunks = 0